import { FC, HTMLAttributes, ReactNode } from 'react';
import { Outlet } from 'react-router-dom';

import { Layout } from 'antd';
import cn from 'classnames';

import { useMedia } from 'shared/hooks';
import { HeaderPublisher } from 'widgets/Header';
import { Sidebar } from 'widgets/Sidebar';

import styles from '../LayoutAdvertiser/Layout.module.scss';

interface ILayoutPublisherProps extends HTMLAttributes<HTMLDivElement> {
	outlet?: ReactNode;
}

export const LayoutPublisher: FC<ILayoutPublisherProps> = ({ className, outlet, ...props }) => {
	const isDesktop = useMedia('desktop');

	return (
		<Layout {...props} className={cn(className, styles.main)}>
			{isDesktop && <Sidebar isPublisher={true} />}
			<Layout className={styles.layout}>
				<HeaderPublisher />
				<Layout.Content className={styles.content}>{outlet || <Outlet />}</Layout.Content>
				{/*<Footer />*/}
			</Layout>
		</Layout>
	);
};
